<template>
  <div>
    <el-form :ref="form.formname" :model="form" label-width="200px" class="etms-router-form">
      <el-form-item label="密保邮箱 ：">
        <el-input size="mini" placeholder="请填写密保邮箱" class="el-width-300" v-model="form.Email" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="邮箱认证状态 ：">
        <span class="cursor" v-show="form.EmailValidateState" @click="activeReplaceClick">已绑定(点击更换邮箱)</span>
        <span class="cursor" v-show="!form.EmailValidateState" @click="activeClick">未激活(点击激活账号绑定)</span>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="emaildialogvisible" :title="emaildialogtitle" :modal-append-to-body="false" width="500px" center>
      <el-form :ref="dialog.formname" :model="form" :rules="dialog.rules" label-width="80px" class="etms-dialog-form">
        <el-form-item label="邮箱" prop="NewEmail">
          <el-input size="mini" placeholder="请填写密保邮箱" class="el-width-250" v-model="form.NewEmail" :disabled="replaceemailstate"></el-input>
          <el-button size="mini" type="primary" @click="sendEmailClick">{{sendemailtitle}}</el-button>
        </el-form-item>
        <el-form-item label="验证码" prop="EmailSecurityCode">
          <el-input size="mini" placeholder="请填写验证码" class="el-width-130" v-model="form.EmailSecurityCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitUserSafeEmail">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    var emailValidate = (rule, value, callback) => {
      var self = this
      self.form.EmailValidateDisabled = false
      if (value === '') {
        callback(new Error('请输入电子邮箱'))
      }
      var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!reg.test(value)) {
        callback(new Error('请输入有效的邮箱'))
      }
      var userinfo = this.$cookies.get('userinfo')
      if (userinfo !== null && userinfo !== undefined) {
        this.$ajax({
          method: 'post',
          url: this.constant.openPaths.existsEmail,
          data: {
            UserId: userinfo.id,
            EnterpriseId: userinfo.enterpriseId,
            LoginToken: userinfo.loginToken,
            Email: value
          }
        }).then(function (res) {
          if (res.data.code === 200) {
            self.form.EmailValidateDisabled = true
            callback()
          } else {
            callback(new Error(res.data.msg))
          }
        }).catch(function (error) {
          self.$message.error(error)
        })
      }
      else {
        callback(new Error('登录失效,请刷新页面'))
      }
    }
    var emailSecurityCodeValidate = (rule, value, callback) => {
      var self = this
      var userinfo = this.$cookies.get('userinfo')
      if (userinfo !== null && userinfo !== undefined) {
        this.$ajax({
          method: 'post',
          url: this.constant.openPaths.registerEmailSCodeValidate,
          data: {
            UserId: userinfo.id,
            EnterpriseId: userinfo.enterpriseId,
            LoginToken: userinfo.loginToken,
            Email: this.form.NewEmail,
            securityCode: this.form.EmailSecurityCode
          }
        }).then(function (res) {
          if (res.data.code === 200) {
            callback()
          } else {
            callback(new Error(res.data.msg))
          }
        }).catch(function (error) {
          self.$message.error(error)
        })
      } else {
        callback(new Error('登录失效,请刷新页面'))
      }
    }
    return {
      emaildialogvisible: false,
      emaildialogtitle: '邮箱认证',
      replaceemailstate: true,
      sendemailtitle: '发送验证码',
      userinfo: this.$cookies.get('userinfo'),
      form: {
        formname: 'safeform',
        OptimisticLock: '',
        Email: '',
        EmailValidateDisabled: false,
        EmailValidateState: false,
        EmailSecurityCode: '',
        totalTime: 0,
        NewEmail: ''
      },
      dialog: {
        formname: 'sendform',
        rules: {
          EmailSecurityCode: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
            { validator: emailSecurityCodeValidate, trigger: 'blur' }
          ],
          NewEmail: [
            { max: 50, message: '长度在50个字符内', trigger: 'blur' },
            { validator: emailValidate, trigger: 'blur' }
          ]
        }
      }
    }
  },
  mounted () {
    if (this.userinfo !== null && this.userinfo !== undefined) {
      var self = this
      this.$ajax.post(this.constant.openPaths.getCurrentUserSafe,
        {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken
        }
      ).then(res => {
        if (res.data.code === 200) {
          var result = res.data.result
          self.form.OptimisticLock = result.optimisticLock
          self.form.Email = result.email
          self.form.EmailValidateState = result.emailValidateState === 1
          if (!self.form.EmailValidateState) {
            self.form.NewEmail = result.email
          }
        }
      }).catch(error => {
        self.$message.error(error)
      })
    }
  },
  methods: {
    activeReplaceClick () {
      this.emaildialogvisible = true
      this.emaildialogtitle = '更换密保邮箱'
      this.replaceemailstate = false
    },
    activeClick () {
      this.emaildialogvisible = true
      this.emaildialogtitle = '密保邮箱认证'
      this.replaceemailstate = true
    },
    sendEmailClick () {
      var self = this
      if (this.form.Email === this.form.NewEmail && this.form.EmailValidateState) {
        this.$message.error('更换后邮箱不能为原邮箱')
        return
      }
      if ((this.form.EmailValidateState && this.form.EmailValidateDisabled) || !this.form.EmailValidateState) {
        this.$ajax({
          method: 'post',
          url: this.constant.openPaths.sendUserSafeEmail,
          data: {
            UserId: this.userinfo.id,
            EnterpriseId: this.userinfo.enterpriseId,
            LoginToken: this.userinfo.loginToken,
            Email: this.form.NewEmail
          }
        }).then(function (res) {
          if (res.data.code === 200) {
            if (self.sendemailtitle === '发送验证码') {
              self.form.totalTime = 90
              var clock = window.setInterval(() => {
                self.form.totalTime--
                self.sendemailtitle = self.form.totalTime
                if (self.form.totalTime < 1) {
                  window.clearInterval(clock)
                  self.sendemailtitle = '发送验证码'
                }
              }, 1000)
            }
          } else {
            self.$message.error(res.data.msg)
          }
        }).catch(function (error) {
          self.$message.error(error)
        })
      }
    },
    submitUserSafeEmail () {
      this.$refs[this.dialog.formname].validate(vali => {
        if (vali) {
          var self = this
          this.$ajax.post(this.constant.openPaths.submitUserSafeEmail, {
            UserId: this.userinfo.id,
            EnterpriseId: this.userinfo.enterpriseId,
            LoginToken: this.userinfo.loginToken,
            OptimisticLock: this.form.OptimisticLock,
            Email: this.form.NewEmail,
            SecurityCode: this.form.EmailSecurityCode
          }).then(res => {
            if (res.data.code === 200) {
              self.$message({ message: res.data.msg, type: 'success' })
              var result = res.data.result
              self.form.OptimisticLock = result.optimisticLock
              self.form.Email = self.form.NewEmail
              self.form.NewEmail = ''
              self.form.EmailSecurityCode = ''
              self.form.EmailValidateState = true
              self.emaildialogvisible = false
              self.form.totalTime = 0
              self.form.sendemailtitle = '发送验证码'
            } else {
              self.$message.error(res.data.msg)
            }
          }).catch(error => {
            self.$message.error(error)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/ems/safe_info.vue